module.exports = __webpack_public_path__ + "img/Weapon_192.fb5e973e.png";